var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-text-glitch"},[_c('div',{staticClass:"c-text-glitch__item glitch",attrs:{"data-text":_vm.text}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }